import { useAppDispatch } from "./store";
import { addSound, SoundType } from "../../reducers/alerts";
import { useCallback } from "react";

export function usePlaySound() {
  const playSound = useCallback(
    (
      durationMs: number,
      frequencyHz: number,
      volume: number = 1,
      type: "sine" | "square" | "sawtooth" | "triangle" = "sine",
      callback?: () => void,
    ) => {
      const audioContext = new (window.AudioContext ||
        window.webkitAudioContext ||
        window.audioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      oscillator.frequency.value = frequencyHz;
      gainNode.gain.value = volume;
      oscillator.type = type;
      if (callback !== undefined) {
        oscillator.onended = callback;
      }

      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + (durationMs || 500) / 1000);
    },
    [],
  );

  const playGoodSound = useCallback(() => {
    void playSound(100, 600, 1, "sine");
  }, [playSound]);

  const playBadSound = useCallback(() => {
    void playSound(100, 200, 1, "sawtooth");
  }, [playSound]);

  return {
    [SoundType.GOOD]: playGoodSound,
    [SoundType.BAD]: playBadSound,
  };
}

export default function useTriggerSounds() {
  const dispatch = useAppDispatch();

  const triggerGoodSound = useCallback(() => {
    dispatch(addSound({ soundType: SoundType.GOOD }));
  }, [dispatch]);

  const triggerBadSound = useCallback(() => {
    dispatch(addSound({ soundType: SoundType.BAD }));
  }, [dispatch]);

  return {
    triggerGoodSound,
    triggerBadSound,
  };
}
